<script>
const stones = [
      {
        type: 'diamonds',
        title: 'Diamond',
        stones: [
          {
            "id": 128, 
            "stoneclass": "diamond", 
            "data-value": "diamond", 
            "title": "Diamond",
            "total": "",
            "disabled": true}, 
          {
            "id": 126, 
            "stoneclass": "blackdiamond", 
            "data-value": "endhanced--black--diamond", 
            "title": "Enhanced Black Diamond", 
            "disabled": true}, 
          {
            "id": 124, 
            "stoneclass": "bluediamond", 
            "data-value": "endhanced--blue--diamond", 
            "title": "Enhanced Blue Diamond", 
            "disabled": true}, 
          {
            "id": 134, 
            "stoneclass": "coffeediamond", 
            "data-value": "coffee--diamond", 
            "title": "Coffee Diamond", 
            "disabled": true}, 
          {
            "id": 133, 
            "stoneclass": "rainbowdiamond", 
            "data-value": "rainbow--diamond", 
            "title": "Rainbow Diamond", 
            "disabled": true}, 
          {
            "id": 125, 
            "stoneclass": "yellowdiamond", 
            "data-value": "yellow--diamond", 
            "title": "Yellow Diamond", 
            "disabled": true}
        ]
      },
      {
        type: 'pearls',
        title: 'Pearl',
        stones:[
          {
            "id": 135, 
            "stoneclass": "koyaculturedpearl", 
            "data-value": "akoya--cultured--pearl", 
            "title": "Akoya Pearl", 
            "disabled": true}, 
          {
            "id": 136, 
            "stoneclass": "freshwaterculturedpearl", 
            "data-value": "reshwater--cultured--pearl", 
            "title": "Freshwater Pearl", 
            "disabled": true}, 
          {
            "id": 137, 
            "stoneclass": "tahitianculturedpearl", 
            "data-value": "ahitian--cultured--pearl", 
            "title": "Tahitian Pearl", 
            "disabled": true}, 
          {
            "id": 138, 
            "stoneclass": "southseaculturedpearl", 
            "data-value": "southseaculturedpearl", 
            "title": "South Sea Pearl", 
            "disabled": true}, 
          {
            "id": 139, 
            "stoneclass": "goldensouthseaculturedpearl", 
            "data-value": "golden--south--sea--cultured--pearl", 
            "title": "Golden South Sea Pearl", 
            "disabled": true}
        ]
      },
      {
        type: 'gemstones',
        title: 'Gemstones',
        stones:[
          {
            "id": 120, 
            "stoneclass": "bluesapphire", 
            "data-value": "blue--sapphire", 
            "title": "Blue Sapphire", 
            "disabled": true}, 
          {
            "id": 140, 
            "stoneclass": "pinksapphire", 
            "data-value": "pink--sapphire", 
            "title": "Pink Sapphire", 
            "disabled": true}, 
          {
            "id": 119, 
            "stoneclass": "emerald", 
            "data-value": "emerald", 
            "title": "Emerald", 
            "disabled": true}, 
          {
            "id": 118, 
            "stoneclass": "ruby", 
            "data-value": "ruby", 
            "title": "Ruby", 
            "disabled": true}, 
          {
            "id": 141, 
            "stoneclass": "opal", 
            "data-value": "opal", 
            "title": "Opal", 
            "disabled": true}, 
          {
            "id": 142, 
            "stoneclass": "aquamarine", 
            "data-value": "aquamarine", 
            "title": "Aquamarine", 
            "disabled": true}, 
          {
            "id": 143, 
            "stoneclass": "morganite", 
            "data-value": "morganite", 
            "title": "Morganite", 
            "disabled": true}, 
          {
            "id": 132, 
            "stoneclass": "garnet", 
            "data-value": "garnet", 
            "title": "Garnet", 
            "disabled": true}, 
          {
            "id": 121, 
            "stoneclass": "amethyst", 
            "data-value": "amethyst", 
            "title": "Amethyst", 
            "disabled": true}, 
          {
            "id": 129, 
            "stoneclass": "peridot", 
            "data-value": "peridot", 
            "title": "Peridot", 
            "disabled": true}, 
          {
            "id": 144, 
            "stoneclass": "londonbluetopaz", 
            "data-value": "london--blue--topaz", 
            "title": "London Blue Topaz", 
            "disabled": true}, 
          {
            "id": 145, 
            "stoneclass": "swissbluetopaz", 
            "data-value": "swissbluetopaz", 
            "title": "Swiss Blue Topaz", 
            "disabled": true}, 
          {
            "id": 122, 
            "stoneclass": "citrine", 
            "data-value": "citrine", 
            "title": "Citrine", 
            "disabled": true}, 
          {
            "id": 146, 
            "stoneclass": "pinktourmaline", 
            "data-value": "pink--tourmaline", 
            "title": "Pink Tourmaline", 
            "disabled": true}, 
          {
            "id": 147, 
            "stoneclass": "blackonyx", 
            "data-value": "black--onyx", 
            "title": "Black Onyx", 
            "disabled": true}, 
          {
            "id": 148, 
            "stoneclass": "moissanite", 
            "data-value": "moissanite", 
            "title": "Moissanite", 
            "disabled": true}, 
          {
            "id": 149, 
            "stoneclass": "tsavorite", 
            "data-value": "tsavorite", 
            "title": "Tsavorite", 
            "disabled": true}, 
          {
            "id": 150, 
            "stoneclass": "tealmontanasapphire", 
            "data-value": "teal--montana--sapphire", 
            "title": "Teal Montana Sapphire", 
            "disabled": true}, 
          {
            "id": 151, 
            "stoneclass": "yellowsapphire", 
            "data-value": "yellow--sapphire", 
            "title": "Yellow Sapphire", 
            "disabled": true}, 
          {
            "id": 152, 
            "stoneclass": "fireopal", 
            "data-value": "fire--opal", 
            "title": "Fire Opal", 
            "disabled": true}, 
          {
            "id": 153, 
            "stoneclass": "moonstone", 
            "data-value": "moonstone", 
            "title": "Moonstone", 
            "disabled": true}, 
          {
            "id": 154, 
            "stoneclass": "orangesapphire", 
            "data-value": "orange--sapphir", 
            "title": "Orange Sapphire", 
            "disabled": true}, 
          {
            "id": 155, 
            "stoneclass": "rosequartz", 
            "data-value": "rose--quartz", 
            "title": "Rose Quartz", 
            "disabled": true}, 
          {
            "id": 156, 
            "stoneclass": "rhodolitegarnet", 
            "data-value": "rhodolite--garnet", 
            "title": "Rhodolite Garnet", 
            "disabled": true}, 
          {
            "id": 157, 
            "stoneclass": "spessartite", 
            "data-value": "spessartite", 
            "title": "Spessartite", 
            "disabled": true}, 
          {
            "id": 158, 
            "stoneclass": "turquoise", 
            "data-value": "turquoise", 
            "title": "Turquoise", 
            "disabled": true}, 
          {
            "id": 123, 
            "stoneclass": "multisapphire", 
            "data-value": "multisapphire", 
            "title": "Multi Sapphire", 
            "disabled": true}, 
          {
            "id": 130, 
            "stoneclass": "tanzanite", 
            "data-value": "tanzanite", 
            "title": "Tanzanite", 
            "disabled": true}, 
          {
            "id": 131, 
            "stoneclass": "lemontopaz", 
            "data-value": "lemontopaz", 
            "title": "Lemon Topaz", 
            "disabled": true}          
        ]
      }
    ];

  export default stones
</script>